import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Order from "@/pages/Order";
import Track from "@/pages/Track";
import Admin from "@/pages/Admin";
import Redirect from "@/pages/Redirect";
import Portal from "@/pages/Portal";
import PortalDashboard from "@/pages/PortalDashboard";
import OrderSuccess from "@/pages/OrderSuccess";
import OrderCancel from "@/pages/OrderCancel";
import AuthCallback from "@/pages/AuthCallback";
import Legal from "@/pages/Legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AppRouter = () => {
  const location = useLocation();
  // Google OAuth returns with #session_id in the fragment — process it synchronously
  // during render (before any route/portal guard runs) per the Emergent Auth playbook.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/order" element={<Order />} />
      <Route path="/order/success" element={<OrderSuccess />} />
      <Route path="/order/cancel" element={<OrderCancel />} />
      <Route path="/track" element={<Track />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/r/:assetId" element={<Redirect />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="/portal/verify" element={<Portal />} />
      <Route path="/portal/dashboard" element={<PortalDashboard />} />
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/terms" element={<Legal doc="terms" />} />
      <Route path="/shipping" element={<Legal doc="shipping" />} />
      <Route path="/returns" element={<Legal doc="returns" />} />
    </Routes>
  );
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="bottom-right" richColors />
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
